import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgKeyboardReturn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 12,
	height: 12,
	viewBox: "0 0 12 12",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#1a78c0",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		id: "Frame 40480",
		children: [/* @__PURE__ */ _jsx("path", {
			id: "Vector 114",
			d: "M1.5 7.5H9C9.55228 7.5 10 7.05228 10 6.5V3C10 2.44772 9.55228 2 9 2H6",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}), /* @__PURE__ */ _jsx("path", {
			id: "Vector 115",
			d: "M4.5 4.5L1.5 7.5L4.5 10.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})]
	})
});
export default SvgKeyboardReturn;
